// import React from "react";
// import { shipFromFields } from "../formFields/asnTabsFields";
// import GenericFormTab from "./GenericFormTab";

// export default function ShipFromTab({ formData, onChange }) {
//   return <GenericFormTab fields={shipFromFields} formData={formData} onChange={onChange} />;
// }




import React from "react";
import { supplierAddressFieldsASN } from "../formFields/asnTabsFields";
import GenericFormTab from "./GenericFormTab";

export default function ShipFromTab({ formData, onChange, formSubmissionAttempted }) {
  return (
    <div>
      <ul className="nav nav-pills mb-3 gap-2 p-2 rounded shadow-sm">
        <li className="nav-item">
          <button type="button" className="nav-link d-flex align-items-center px-2 py-1 fw-semibold active btn-primary text-white">
            <i className="bi bi-box-seam me-2"></i> Ship From
          </button>
        </li>
      </ul>

      <div className="tab-content rounded p-3">
        <GenericFormTab
          fields={supplierAddressFieldsASN}
          formData={formData}
          onChange={onChange}
          formSubmissionAttempted={formSubmissionAttempted}
        />
      </div>
    </div>
  );
}
